import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Fade, Reveal} from 'react-reveal/';

class About extends Component {
    render(){
        let ifontanaData = this.props.ifontanaData; 
        var {aClass} = this.props;
        return(
            <section className={`${aClass}`} id="about">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 d-flex align-items-center">
                            <Fade bottom cascade duration={1000}>
                                <div className="about_content">
                                    <h2 className="t_color">{ifontanaData.aboutme}</h2>
                                    <h6>{ifontanaData.name3}</h6>
                                    <p>{ifontanaData.aboutdetails}<br/>
                                    {ifontanaData.aboutdetails2}<br/>
                                    {ifontanaData.aboutdetails3}<br/></p>
                                </div>
                            </Fade>
                        </div>
                        <div className="col-lg-5">
                            <div className="about_img">
                                <Reveal effect="fadeInRight" duration={7500}><img src={require('../image/about.jpg')} alt=""/></Reveal>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
export default About;
